import React from "react";
import { Button, ConfigProvider, Descriptions } from "antd";
import style from "css/modal.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  openConfirm,
  closeAlert,
  openAlert,
} from "../../redux/slices/alertSlice";
import { useMediaQuery } from "react-responsive";
import dayjs from "dayjs";

function CompleteLicense(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 769px) and (max-width: 1023px)",
  });
  //dispatch
  const dispatch = useDispatch();

  //payload
  const userPayload = useSelector((state) => state.user);
  const descriptionItem = [
    {
      key: 1,
      label: "학번/교번",
      children: userPayload.userId,
      span: "filled",
    },
    { key: 2, label: "이메일", children: userPayload.email, span: "filled" },
    { key: 3, label: "이름", children: userPayload.userNm, span: "filled" },
    {
      key: 4,
      label: "신청일시",
      children: dayjs().format("YYYY-MM-DD HH:mm"),
      span: "filled",
    },
    { key: 5, label: "상태", children: "승인대기", span: "filled" },
  ];
  const closeModal = () => {
    props.setStatus("apply");
    props.close();
    props.refresh();
  };
  return (
    <div className={style.license_complete_modal}>
      <div className={style.modal_title_wrapper}>
        <img
          alt="complete"
          src={`${process.env.REACT_APP_CLIENT_URL}img/my/complete.png`}
        />
        <span className={style.modal_title}>
          {props.product.PRODUCT_NM + " 계정 신청이 완료되었습니다."}
        </span>
        <span className={style.modal_subtitle}>
          {
            "신청하신 내용을 검토 중입니다.\n승인 완료시 등록하신 이메일로 안내가 발송됩니다."
          }
        </span>
      </div>
      <div className={style.license_notice_wrap}>
        <div className={style.license_notice_label}>
          <img
            alt="notice"
            src={`${process.env.REACT_APP_CLIENT_URL}img/my/notice.png`}
          />
          <span>안내사항</span>
        </div>
        <div className={style.license_notice_contents}>
          {`신청 승인은 영업일 기준 1~2일 소요됩니다.\n승인 완료 후 Adobe 초대 메일이 발송됩니다.\n신청 결과는 하단의 '계정 신청 결과 확인'에서 조회 가능합니다.`}
        </div>
      </div>
      <div className={style.modal_horizon_line}></div>
      <ConfigProvider
        theme={{
          components: {
            Descriptions: {
              fontSize: isMobile || isTablet ? 14 : 16,
              fontFamily: "Pretendard",
              labelBg: "#527ff2",
              colorTextSecondary: "#ffffff",
              colorSplit: "#bdc0c5",
              paddingSM: 10,
              paddingLG: isMobile || isTablet ? 15 : 40,
            },
          },
        }}
      >
        <Descriptions bordered size="middle" items={descriptionItem} />
      </ConfigProvider>

      <div className={style.modal_footer}>
        <ConfigProvider
          theme={{
            components: {
              Button: {
                fontFamily: "Pretendard",
                colorPrimaryHover: "#527ff2",
                colorPrimaryActive: "#527ff2",
              },
            },
          }}
        >
          <Button
            type="primary"
            className={style.modal_submit_btn}
            onClick={() => {
              closeModal();
            }}
          >
            확인
          </Button>
        </ConfigProvider>
      </div>

      <div className={style.license_inquiry_wrap}>
        <div className={style.license_inquiry_label}>문의</div>
        <div className={style.license_inquiry_tel}>
          <img
            alt="tel"
            src={`${process.env.REACT_APP_CLIENT_URL}img/my/tel.png`}
          />
          <span>02-4654-8651</span>
        </div>
        <div className={style.modal_vertical_line} />
        <div className={style.license_inquiry_email}>
          <img
            alt="email"
            src={`${process.env.REACT_APP_CLIENT_URL}img/my/email.png`}
          />
          <span>support@university.ac.kr</span>
        </div>
      </div>
    </div>
  );
}

export default CompleteLicense;
